import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getFormSubmissions = (axios: IAxiosInstance) => {
  return async (
    params: ISchema["#/definitions/TGetMultiFormSubmissionQuery"]
  ) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/TGetMultiFormSubmissionResponse"]
    >(`/forms`, {
      params,
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
